import axiosInstance from "../axiosInstance";

export const downloadOrders = async () => {
  try {
    const userData = JSON.parse(localStorage.getItem("userPartnerData"));
    const token = userData?.token;

    const response = await axiosInstance.get("/download_documents", {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    return response;
  } catch (error) {
    console.error("Error fetching services data", error);
    throw error;
  }
};
